export enum UpdateStatusTypes {
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_IN_PROGRESS = 'NOT_IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export default UpdateStatusTypes;
